import React from 'react'
import { Header } from '../components'

const CategorySpecific = () => {
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header title="Category Specific Keyword Analysis" />
      <p>Category Specific Keyword Analysis</p>
    </div>
  )
}

export default CategorySpecific;